<template>
  <v-dialog v-model="dialog" max-width="1350px">
    <template v-slot:activator="{ on }">
      <div>
        <v-btn
          v-on="on"
          class="button-style-blue ma-0"
          dark
        >
          Add Enrollment Template <v-icon dark class="ml-1">add</v-icon>
        </v-btn>
      </div>
    </template>
    <v-form
      ref="form"
      lazy-validation
      @submit.prevent="submitEnrollmentTemplateForm"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Enrollment Template Form</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="fluid-full">
            <v-layout row wrap>
              <v-flex xs12 md4>
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Enrollment Details</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-select
                            v-model="newEnrollmentTemplate.school_year"
                            item-text="name"
                            item-value="id"
                            :items="schoolYears"
                            :rules="[v => !!v || 'School Year Level is required']"
                            required
                            color="#091D3B"
                            label="School Year">
                          </v-select>
                          <v-select
                            v-model="newEnrollmentTemplate.grade_level"
                            item-text="text"
                            item-value="value"
                            @change="changeTrackType"
                            :items="gradeLevels"
                            :rules="[v => !!v || 'Grade Level is required']"
                            required
                            color="#091D3B"
                            label="Grade Level">
                          </v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              v-model="newEnrollmentTemplate.payment_plan"
                              :items="paymentPlan"
                              item-text="text"
                              item-value="value"
                              :rules="[v => !!v || 'Payment Plan is required']"
                              color="#091D3B"
                              label="Payment Plan">
                            </v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              v-model="newEnrollmentTemplate.enrollment_type"
                              :items="enrollmentType"
                              item-text="text"
                              item-value="value"
                              :rules="[v => !!v || 'Enrollment Type is required']"
                              required
                              color="#091D3B"
                              label="Enrollment Type">
                            </v-select>
                          </v-flex>
                          <v-select
                            v-model="newEnrollmentTemplate.track_type"
                            item-text="text"
                            item-value="value"
                            :items="trackType"
                            :disabled="(newEnrollmentTemplate.grade_level < 14 ? true : false)"
                            color="#091D3B"
                            label="Track Type">
                          </v-select>
                          <!-- ADD BOOKS SECTION -->
                          <v-flex xs12>
                            <v-card>
                              <v-expansion-panel expand v-model="bookPanel">
                                <v-expansion-panel-content>
                                  <template v-slot:header>
                                    <div>Books ({{newEnrollmentTemplate.books.length}})</div>
                                  </template>
                                    <v-card-text v-if="newEnrollmentTemplate.books.length >= 1">
                                      <v-layout v-for="(book, index) in newEnrollmentTemplate.books">
                                        <v-flex xs5>
                                          <v-text-field :rules="[v => !!v || 'Subject is required']" color="#091D3B" label="Subject" v-model="book.subject"> </v-text-field>
                                        </v-flex>
                                        <v-flex xs5>
                                          <v-currency-field
                                            :rules="
                                              [
                                                v => !!v || 'Price is required',
                                                v => parseFloat(v) > 0 || 'Price cannot be less than or equal to 0',
                                              ]"
                                            prefix="₱"
                                            color="#091D3B"
                                            label="Price"
                                            :type="'number'"
                                            v-model="book.price"> </v-currency-field>
                                        </v-flex>
                                        <v-flex xs2>
                                          <v-btn style="padding: 0 10px;" color="#B71C1C" dark class="small-button" @click="deleteBook(index)"><v-icon small>close</v-icon></v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-text primary-title>
                                        <v-flex xs12>
                                          <v-btn block class="button-style-blue" @click="addBook">Add Books</v-btn>
                                        </v-flex>
                                    </v-card-text>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-card>
                          </v-flex>
                          <!-- ADD BOOKS SECTION END-->
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Downpayment</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                v-model="newEnrollmentTemplate.tuition_fee"
                                color="#091D3B"
                                label="Tuition Fee"
                                :type="'number'"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                v-model="newEnrollmentTemplate.registration_fee"
                                color="#091D3B"
                                label="Registration Fee"
                                :type="'number'"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                v-model="newEnrollmentTemplate.miscellaneous_fee"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Miscellaneous Fee">
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                v-model="newEnrollmentTemplate.computer_fee"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Computer Fee">
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                v-model="totalBooksFee"
                                type="number"
                                color="#091D3B"
                                prefix="₱"
                                label="Books"
                                disabled
                              >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                v-model="newEnrollmentTemplate.esc_subsidy"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="ESC Subsidy">
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                :value="totalDown"
                                :messages="toWords(totalDown)"
                                color="#091D3B"
                                prefix="₱"
                                label="Total Downpayment"
                                disabled>
                              </v-currency-field>
                            </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Installment</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="newEnrollmentTemplate.num_installments"
                              type="number"
                              color="#091D3B"
                              label="Number of Installments">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-currency-field
                              v-model="newEnrollmentTemplate.installment_amount"
                              :type="'number'"
                              color="#091D3B"
                              prefix="₱"
                              label="Installment Amount">
                            </v-currency-field>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-card class="button-style-blue mt-4">
                  <v-toolbar flat class="button-style-blue pt-2">
                    <span class="title"><strong>Total</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-currency-field
                            class="disabled-field-underline important"
                            :value="total"
                            :messages="toWords(total)"
                            :type="'number'"
                            color="#091D3B"
                            prefix="₱"
                            label="Total Tuition" disabled>
                          </v-currency-field>
                        </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#091D3B" outline @click="close">Close</v-btn>
          <v-btn type="submit" class="button-style-blue">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import numberToWords from 'number-to-words'

export default {
  name: 'enrollment',
  props: {
    enrollment: Object
  },
  computed: {
    ...mapState(['schoolYears']),
    totalDown () {
      return (
        (this.newEnrollmentTemplate.tuition_fee ? parseFloat(this.newEnrollmentTemplate.tuition_fee): 0) +
        (this.newEnrollmentTemplate.registration_fee ? parseFloat(this.newEnrollmentTemplate.registration_fee) : 0) +
        (this.newEnrollmentTemplate.miscellaneous_fee ? parseFloat(this.newEnrollmentTemplate.miscellaneous_fee) : 0) +
        (this.newEnrollmentTemplate.computer_fee ? parseFloat(this.newEnrollmentTemplate.computer_fee) : 0) +
        (this.totalBooksFee ? parseFloat(this.totalBooksFee) : 0) -
        (this.newEnrollmentTemplate.esc_subsidy ? parseFloat(this.newEnrollmentTemplate.esc_subsidy) : 0)
      ).toFixed(2);
    },
    total () {
      var totalDown = (
        (this.newEnrollmentTemplate.tuition_fee ? parseFloat(this.newEnrollmentTemplate.tuition_fee): 0) +
        (this.newEnrollmentTemplate.registration_fee ? parseFloat(this.newEnrollmentTemplate.registration_fee) : 0) +
        (this.newEnrollmentTemplate.miscellaneous_fee ? parseFloat(this.newEnrollmentTemplate.miscellaneous_fee) : 0) +
        (this.newEnrollmentTemplate.computer_fee ? parseFloat(this.newEnrollmentTemplate.computer_fee) : 0) +
        (this.totalBooksFee ? parseFloat(this.totalBooksFee) : 0) -
        (this.newEnrollmentTemplate.esc_subsidy ? parseFloat(this.newEnrollmentTemplate.esc_subsidy) : 0)
      );
      var totalInstallment = (
        (this.newEnrollmentTemplate.num_installments ? parseFloat(this.newEnrollmentTemplate.num_installments): 0) *
        (this.newEnrollmentTemplate.installment_amount ? parseFloat(this.newEnrollmentTemplate.installment_amount) : 0)
      );
      return (totalDown + totalInstallment).toFixed(2);
    },
    totalBooksFee () {
      return (this.newEnrollmentTemplate.books.reduce((accumulator, currentValue) => {
        return accumulator + (currentValue.price ? parseFloat(currentValue.price) : 0)
      }, 0)).toFixed(2)
    },
  },
  data () {
    return {
      bookPanel: [true],
      dialog: false,
      paymentPlan: [
        { value: 1, text: 'Monthly (June to March)'},
        { value: 2, text: 'Quarterly (Jun/Sep/Dec/Mar)'},
        { value: 3, text: 'Half Payment (November)'},
        { value: 4, text: 'Full Payment'}
      ],
      enrollmentType: [
        { value: 1, text: 'Old'},
        { value: 2, text: 'Transferee (Public School)'},
        { value: 3, text: 'Transferee (Private School)'},
        { value: 4, text: 'New'},
        { value: 5, text: 'All'}
      ],
      gradeLevels: [
        { value: 1,  text: 'Nursery'},
        { value: 2,  text: 'Kinder 1'},
        { value: 3,  text: 'Kinder 2'},
        { value: 4,  text: 'Grade 1'},
        { value: 5,  text: 'Grade 2'},
        { value: 6,  text: 'Grade 3'},
        { value: 7,  text: 'Grade 4'},
        { value: 8,  text: 'Grade 5'},
        { value: 9,  text: 'Grade 6'},
        { value: 10, text: 'Grade 7'},
        { value: 11, text: 'Grade 8'},
        { value: 12, text: 'Grade 9'},
        { value: 13, text: 'Grade 10'},
        { value: 14, text: 'Grade 11'},
        { value: 15, text: 'Grade 12'}
      ],
      trackType: [
        { value: 1, text: 'N/A'},
        { value: 2, text: 'Academic'},
        { value: 3, text: 'Tech/Voc - Home Economics - Cookery/Baking and Pastry'}
      ],
      newEnrollmentTemplate: {
        id: null,
        grade_level: null,
        payment_plan: null,
        enrollment_type: null,
        track_type: 1,
        school_year: null,
        section: null,
        tuition_fee: 0,
        registration_fee: 0,
        miscellaneous_fee: 0,
        computer_fee: 0,
        num_installments: 0,
        installment_amount: 0,
        esc_subsidy: 0,
        books: [],
      }
    }
  },
  methods: {
    ...mapActions([
      'createEnrollmentTemplate',
      'updateEnrollmentTemplate',
      'getEnrollmentTemplates',
      'getSchoolYears',
    ]),
    changeTrackType() {
      if (this.newEnrollmentTemplate.grade_level <= 13) {
          this.newEnrollmentTemplate.track_type = 1
      }
    },
    toWords (total) {
      if (! total) {
        return ''
      }
      return numberToWords.toWords(total);
    },
    addBook () {
      this.newEnrollmentTemplate.books.push({subject: '', price: 0})
    },
    deleteBook (index) {
      confirm('Are you sure you want to remove') && this.newEnrollmentTemplate.books.splice(index, 1)
    },
    resetData () {
      this.newEnrollmentTemplate = {
        id: null,
        grade_level: null,
        payment_plan: null,
        enrollment_type: null,
        track_type: 1,
        school_year: null,
        section: null,
        tuition_fee: 0,
        registration_fee: 0,
        miscellaneous_fee: 0,
        computer_fee: 0,
        num_installments: 0,
        installment_amount: 0,
        esc_subsidy: 0,
        books: [],
      }
    },
    addEnrollmentTemplate () {
      const data = Object.assign(this.newEnrollmentTemplate)
      this.createEnrollmentTemplate(data)
        .then((data) => {
          this.initialize()
          this.dialog = false
        })
        .catch((data) => {
          this.$toastr('error', Object.values(data), 'Error')
        })
    },
    editEnrollmentTemplate () {
      const data = Object.assign(this.newEnrollmentTemplate)
      this.updateEnrollmentTemplate(data)
        .then((data) => {
          this.initialize()
          this.dialog = false
        })
        .catch((data) => {
          this.$toastr('error', Object.values(data), 'Error')
        })
    },
    submitEnrollmentTemplateForm() {
      if (this.$refs.form.validate()) {
        this.newEnrollmentTemplate.id ? this.editEnrollmentTemplate() : this.addEnrollmentTemplate()
      }
    },
    close () {
      this.$refs.form.resetValidation()
      this.dialog = false
      this.resetData()
    },
    initialize () {
      this.getEnrollmentTemplates()
      this.getSchoolYears()
    }
  },
  created () {
    this.initialize()
  },
}
</script>
